import { IComponentOptions } from "angular";
import { MachineDetailConfigurationsWarehouseController } from "./controller";

export const vsComponentName = "machineDetailConfigurationsWarehouse";

export const MachineDetailConfigurationsWarehouseComponentOptions: IComponentOptions =
  {
    controller: MachineDetailConfigurationsWarehouseController,
    template: require("!html-loader!./index.html").default,
    controllerAs: "componentController",
    bindings: {
      machine: "<",
    },
  };
